/**
 * Main
 * @author David <david.prenninger@gmx.de>
 *
 * Entrypoint for application script.
 *
 */
import Vue from 'vue';
import ToggleButton from 'vue-js-toggle-button';
import vueCountryRegionSelect from 'vue-country-region-select';
import MultiSourceFileInput from 'vue-multi-source-file-input';
import App from './App.vue';
import i18n from './i18n';
import store from './store';
import router from './router';

Vue.use(vueCountryRegionSelect);
Vue.use(ToggleButton);
Vue.use(MultiSourceFileInput);

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#mk-configurator');
